module.exports = __webpack_public_path__ + "img/product4.0f4f5727.png";